<section>
  <div class="exam-view-header w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
    [style]="{ 'border-color': 'var(--primary-gray)' }">
    <h2 class="text-xl font-semibold" data-clarity-unmask="true">Podgląd egzaminu</h2>
    <div class="exam-view-actions flex gap-2">
      <p-button [outlined]="true" icon="pi pi-file-pdf" label="Pobierz PDF" (onClick)="printExam()" data-clarity-unmask="true"></p-button>
      <p-button styleClass="mr-4" icon="pi pi-calendar" label="Zmień datę egzaminu"
        (onClick)="changeExamDate()" data-clarity-unmask="true"></p-button>
      <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" [disabled]="loading"
        (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
    </div>
  </div>
</section>

<section>
  <div *ngIf="data.wordExamDetails" class="mb-3">
    <div class="flex flex-column">
      <div class="font-semibold">
        Data: {{ data.wordExamDetails.end | date : "dd.MM.yyyy HH:mm" }}
      </div>
      <div class="text-center text-xl md:text-2xl">
        Arkusz przebiegu części teoretycznej egzaminu wewnętrznego
      </div>
      <div class="text-center text-xl md:text-2xl font-semibold">
        Kategoria: {{ data.wordExamDetails.examCategory }}
      </div>
      <div class="exam-view-columns flex gap-8 mt-3">
        <div class="flex flex-column gap-2 w-full">
          <div class="flex justify-content-between">
            <div>Imię:</div>
            <div>{{ data.wordExamDetails.studentFirstName }}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Nazwisko:</div>
            <div>{{ data.wordExamDetails.studentLastName }}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Pesel:</div>
            <div>{{ data.wordExamDetails.studentPesel }}</div>
          </div>
          <div class="flex justify-content-between">
            <div>PKK:</div>
            <div>{{ data.wordExamDetails.studentPKK }}</div>
          </div>
        </div>
        <div class="flex flex-column gap-2 w-full">
          <div class="flex justify-content-between">
            <div>Liczba pytań:</div>
            <div>{{ data.wordExamDetails.examQuestions?.length }}</div>
          </div>
          <div class="flex justify-content-between">
            <div>ID egzaminu:</div>
            <div>{{ data.wordExamDetails.guid.slice(-6) }}</div>
          </div>
        </div>
      </div>
      <div class="text-center text-xl md:text-2xl font-semibold my-2" [ngClass]="getExamStatus().color">
        {{ getExamStatus().label }}
      </div>
      <div class="exam-view-columns flex gap-8 mt-3">
        <div class="flex flex-column gap-2 w-full">
          <div class="flex justify-content-between">
            <div>Poprawne odpowiedzi:</div>
            <div>{{ userAnswerCounts.correct }}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Błędne odpowiedzi:</div>
            <div>{{ userAnswerCounts.incorrect }}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Liczba uzyskanych punktów:</div>
            <div>{{ data.wordExamDetails.earnedPoints }}</div>
          </div>
        </div>
        <div class="flex flex-column gap-2 w-full"></div>
      </div>
    </div>
  </div>

  <div class="exam-view-table">
    <table class="styled-table">
      <thead>
        <tr>
          <th class="text-center">Lp.</th>
          <th class="w-6rem">ID pytania</th>
          <th>Treść pytania</th>
          <th class="text-center">Klucz odpowiedzi</th>
          <th class="text-center">Udzielona odpowiedź</th>
          <th class="text-center">Punkty</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor=" let question of data.wordExamDetails.examQuestions; let i = index">
          <td class="text-center">{{ i + 1 }}</td>
          <td>{{ question.questionNumber.slice(-6) }}</td>
          <td>{{ question.question }}</td>
          <td class="text-center">{{ question.correctAnswer }}</td>
          <td class="text-center">
            {{ question.userGiveCorrectAnswer ? "Dobra" : "Zła" }}
          </td>
          <td class="text-center">{{ question.examPoints }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<section id="printSection" class="hidden">
  <div class="mb-3">
    <div class="main-section">
      <p class="exam-date-field">
        Data: {{ data.wordExamDetails.end | date : "dd.MM.yyyy HH:mm" }}
      </p>
      <p class="font-normal	text-center text-base">
        Arkusz przebiegu części teoretycznej egzaminu wewnętrznego
      </p>
      <p class="font-semibold text-center text-base ">
        Kategoria: {{ data.wordExamDetails.examCategory }}
      </p>

      <div class="details-container">
        <div class="details-column">
          <div class="details-row ">
            <p>Imię:</p>
            <p>{{ data.wordExamDetails.studentFirstName }}</p>
          </div>
          <div class="details-row">
            <p>Nazwisko:</p>
            <p>{{ data.wordExamDetails.studentLastName }}</p>
          </div>
          <div class="details-row">
            <p>Pesel:</p>
            <p>{{ data.wordExamDetails.studentPesel }}</p>
          </div>
          <div class="details-row">
            <p>PKK:</p>
            <p>{{ data.wordExamDetails.studentPKK }}</p>
          </div>
        </div>
        <div class="details-column">
          <div class="details-row">
            <p>Liczba pytań:</p>
            <p> {{data.wordExamDetails.examQuestions?.length }}</p>
          </div>
          <div class="details-row">
            <p>ID egzaminu:</p>
            <p>{{data.wordExamDetails.guid.slice(-6)}}</p>
          </div>
        </div>
      </div>
      <div>
        <p class="text-center text-base font-semibold text-green-500" *ngIf="data.wordExamDetails.earnedPoints >= data.wordExamDetails.minimumPoints" > Egzamin zaliczony</p>
        <p class="text-center text-base font-semibold text-red-500" *ngIf="data.wordExamDetails.earnedPoints < data.wordExamDetails.minimumPoints"> Egzamin niezaliczony</p>
      </div>
      <div class="details-container">
        <div class="details-column">
          <div class="details-row">
            <p>Poprawne odpowiedzi:</p>
            <p>{{ userAnswerCounts.correct }}</p>
          </div>
          <div class="details-row">
            <p>Błędne odpowiedzi:</p>
            <p>{{ userAnswerCounts.incorrect }}</p>
          </div>
          <div class="details-row">
            <p>Liczba uzyskanych punktów:</p>
            <p>{{ data.wordExamDetails.earnedPoints }}</p>
          </div>
        </div>
        <div class="details-column">&nbsp;</div>
      </div>
    </div>
  </div>



  <div class="grid">
    <div class="col-6">
      <table class="styled-print-table">
        <thead>
          <tr>
            <th>Lp.</th>
            <th>ID</th>
            <th>Klucz odpowiedzi</th>
            <th>Udzielona odpowiedź</th>
            <th>Punkty</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let question of firstTableData; let i = index">
            <td>{{i + 1}}</td>
            <td>{{question.questionNumber}}</td>
            <td>{{question.correctAnswer}}</td>
            <td>{{question.userGiveCorrectAnswer ? 'Dobra' : 'Zła'}}</td>
            <td>{{question.examPoints}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-6">
      <table class="styled-print-table">
        <thead>
          <tr>
            <th>Lp.</th>
            <th>ID</th>
            <th>Klucz odpowiedzi</th>
            <th>Udzielona odpowiedź</th>
            <th>Punkty</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let question of secondTableData; let i = index">
            <td>{{firstTableData.length + i + 1}}</td>
            <td>{{question.questionNumber}}</td>
            <td>{{question.correctAnswer}}</td>
            <td>{{question.userGiveCorrectAnswer ? 'Dobra' : 'Zła'}}</td>
            <td>{{question.examPoints}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


  <div class="footer-section">
    <div class="w-full">
      <div class="separator">&nbsp;</div>
      <p class="signature">Podpis osoby egzaminowanej</p>
    </div>
    <div class="w-full">
      <div class="separator">&nbsp;</div>
      <p class="signature">Podpis i pieczęć instruktora lub wykładowcy przeprowadzającego egzamin</p>
    </div>
  </div>
</section>

<!-- <section id="printSection" class="m-3">
  <div *ngIf="data.wordExamDetails" class="mb-3">
    <div class="flex flex-column">
      <div class="font-semibold">Data: {{data.wordExamDetails.end | date: "dd.MM.yyyy HH:mm"}}</div>
      <div class="text-center text-2xl">
        Arkusz przebiegu części teoretycznej egzaminu wewnętrznego
      </div>
      <div class="text-center text-2xl font-semibold">Kategoria: {{data.wordExamDetails.examCategory}}</div>
      <div class="flex gap-8 mt-3">
        <div class="flex flex-column gap-2 w-full">
          <div class="flex justify-content-between">
            <div>Imię:</div>
            <div>{{data.wordExamDetails.studentFirstName}}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Nazwisko:</div>
            <div>{{data.wordExamDetails.studentLastName}}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Pesel:</div>
            <div>{{data.wordExamDetails.studentPesel}}</div>
          </div>
          <div class="flex justify-content-between">
            <div>PKK:</div>
            <div>{{data.wordExamDetails.studentPKK}}</div>
          </div>
        </div>
        <div class="flex flex-column gap-2 w-full">
          <div class="flex justify-content-between">
            <div>Liczba pytań:</div>
            <div>{{data.wordExamDetails.examQuestions?.length}}</div>
          </div>
          <div class="flex justify-content-between">
            <div>ID egzaminu:</div>
            <div>{{data.wordExamDetails.guid.slice(-6)}}</div>
          </div>
        </div>
      </div>
      <div class="text-center text-2xl font-semibold  my-2" [ngClass]="getExamStatus().color">
        {{getExamStatus().label}}
      </div>
      <div class="flex gap-8 mt-3">
        <div class="flex flex-column gap-2 w-full">
          <div class="flex justify-content-between">
            <div>Poprawne odpowiedzi:</div>
            <div>{{userAnswerCounts.correct}}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Błędne odpowiedzi:</div>
            <div>{{userAnswerCounts.incorrect}}</div>
          </div>
          <div class="flex justify-content-between">
            <div>Liczba uzyskanych punktów:</div>
            <div>{{data.wordExamDetails.earnedPoints}}</div>
          </div>
        </div>
        <div class="flex flex-column gap-2 w-full"></div>
      </div>
    </div>
  </div>
  <fas-service-dynamic-table [columns]="questionListColums" [dataMode]="'client'"
    [fullDataService]="fetchExamQuestionDetails" [paginator]="false" [isTransparentHeader]="true"
    [styleClass]="'p-datatable-sm p-datatable-striped'">
  </fas-service-dynamic-table>
</section> -->